function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "vauto");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 117.43,
  height: 117.43,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 60.21,
  cy: 60.21,
  r: 15.01,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref5 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 105.56,
  cy: 60.21,
  rx: 5.71,
  ry: 15.01,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref6 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 15.61,
  cy: 60.21,
  rx: 5.71,
  ry: 15.01,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref7 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 60.21,
  cy: 105.79,
  rx: 15.01,
  ry: 5.71,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref8 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 60.21,
  cy: 14.64,
  rx: 15.01,
  ry: 5.71,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 129.16,
  y: 1.5,
  width: 117.43,
  height: 117.43,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref10 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 187.87,
  cy: 60.21,
  r: 15.01,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref11 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 233.22,
  cy: 60.21,
  rx: 5.71,
  ry: 15.01,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref12 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 143.27,
  cy: 60.21,
  rx: 5.71,
  ry: 15.01,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref13 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 187.87,
  cy: 105.79,
  rx: 15.01,
  ry: 5.71,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref14 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 187.87,
  cy: 14.64,
  rx: 15.01,
  ry: 5.71,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 129.16,
  y: 128.03,
  width: 117.43,
  height: 117.43,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref16 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 187.87,
  cy: 186.74,
  r: 15.01,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref17 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 233.22,
  cy: 186.74,
  rx: 5.71,
  ry: 15.01,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref18 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 143.27,
  cy: 186.74,
  rx: 5.71,
  ry: 15.01,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref19 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 187.87,
  cy: 232.32,
  rx: 15.01,
  ry: 5.71,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref20 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 187.87,
  cy: 141.17,
  rx: 15.01,
  ry: 5.71,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1.5,
  y: 128.03,
  width: 117.43,
  height: 117.43,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 60.21,
  cy: 186.74,
  r: 15.01,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref23 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 105.56,
  cy: 186.74,
  rx: 5.71,
  ry: 15.01,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref24 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 15.61,
  cy: 186.74,
  rx: 5.71,
  ry: 15.01,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref25 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 60.21,
  cy: 232.32,
  rx: 15.01,
  ry: 5.71,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref26 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 60.21,
  cy: 141.17,
  rx: 15.01,
  ry: 5.71,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref27 =
/*#__PURE__*/
React.createElement("line", {
  x1: 140.45,
  y1: 60.21,
  x2: 158.81,
  y2: 60.21,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref28 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#000",
  points: "152.18 68.39 150.82 66.93 158.04 60.22 150.82 53.5 152.18 52.04 160.98 60.22 152.18 68.39"
});

var _ref29 =
/*#__PURE__*/
React.createElement("line", {
  x1: 87.73,
  y1: 60.21,
  x2: 108.25,
  y2: 60.21,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref30 =
/*#__PURE__*/
React.createElement("line", {
  x1: 187.87,
  y1: 139.86,
  x2: 187.87,
  y2: 158.21,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref31 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#000",
  points: "179.69 151.59 181.16 150.22 187.87 157.44 194.58 150.22 196.05 151.59 187.87 160.38 179.69 151.59"
});

var _ref32 =
/*#__PURE__*/
React.createElement("line", {
  x1: 187.87,
  y1: 87.13,
  x2: 187.87,
  y2: 107.66,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref33 =
/*#__PURE__*/
React.createElement("line", {
  x1: 108.25,
  y1: 186.74,
  x2: 89.9,
  y2: 186.74,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref34 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#000",
  points: "96.53 178.56 97.89 180.03 90.67 186.74 97.89 193.46 96.53 194.92 87.73 186.74 96.53 178.56"
});

var _ref35 =
/*#__PURE__*/
React.createElement("line", {
  x1: 160.98,
  y1: 186.74,
  x2: 140.45,
  y2: 186.74,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref36 =
/*#__PURE__*/
React.createElement("line", {
  x1: 60.21,
  y1: 107.66,
  x2: 60.21,
  y2: 89.3,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref37 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#000",
  points: "68.39 95.93 66.93 97.29 60.22 90.07 53.5 97.29 52.04 95.93 60.22 87.13 68.39 95.93"
});

var _ref38 =
/*#__PURE__*/
React.createElement("line", {
  x1: 60.21,
  y1: 160.38,
  x2: 60.21,
  y2: 139.86,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var SvgVauto = function SvgVauto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "eafe5c3a-b3c3-44d8-8dba-4286961267d9",
    "data-name": "Layer 1",
    viewBox: "0 0 248.09 246.96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVauto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vauto.19441670.svg";
export { ForwardRef as ReactComponent };